/**
* @file Entity component for entity input
* @author Heino Lenting
*/
import * as tslib_1 from "tslib";
import { TranslateService } from '@ngx-translate/core';
import { EntityKey } from 'breeze-client';
import { OverlayService } from '../../../core/overlay.service';
import { AlertsService } from '../../../core/alerts.service';
import { LookupInput } from '../input-lookup/input-lookup';
import { DomainService } from '../../../domain.service';
import { LocalisationService } from '../../../core/localisation.service';
/**
 * Class for entity component.
 */
var InputEntityComponent = /** @class */ (function (_super) {
    tslib_1.__extends(InputEntityComponent, _super);
    /**
     * Constructs an InputEntityComponent
     * @param element Reference to HTML document element
     * @param domainService The domain service
     * @param alertsService Alerts service to display user information.
     * @param elementRef Reference to html element.
     */
    function InputEntityComponent(domainService, alertsService, translateService, localisationService, overlayService) {
        var _this = _super.call(this, domainService, alertsService, translateService, localisationService) || this;
        _this.overlayService = overlayService;
        return _this;
    }
    /**
     * @returns {boolean} True if the input is configured as a dropdown.
     */
    InputEntityComponent.prototype.isDropdown = function () {
        return this.format ? this.format.dropdown : false;
    };
    /**
     * Sets the value after the selection has changed.
     * @param {Event} event The selection changed event.
     */
    InputEntityComponent.prototype.selectionChanged = function (event) {
        var id = event.target.value;
        var values = [id];
        if (id.indexOf('K_-') !== 0) {
            values = id.split('_');
        }
        var key = new EntityKey(this.entityType, values);
        var item = this.items.find(function (i) { return i.entityAspect.getKey().equals(key); });
        this.setValue(item);
    };
    /**
     * Open any given entity via a modal
     * @param entity The entity to open
     */
    InputEntityComponent.prototype.openEntityInModal = function (entity) {
        if (!entity) {
            return;
        }
        // Go to entity
        if (!this.overlayService.goToEntity(entity, this.getLinkName(entity))) {
            this.alertsService.createAlert('warning', 'APP.INPUTS.CAN_NOT_GO_TO_ENTITY');
        }
    };
    /**
     * Gets the link name of the entity to use when displaying the entity in modal mode.
     * @private
     * @param {Entity} entity The entity to display in modal mode.
     * @returns The link name of the entity.
     * @memberOf InputEntityComponent
     */
    InputEntityComponent.prototype.getLinkName = function (entity) {
        if (entity == null) {
            return null;
        }
        var enitityTypeName = entity.entityType.shortName;
        switch (enitityTypeName) {
            case 'Assignment':
                if (entity['Appointment']) {
                    return 'Assignment-is-appointment';
                }
                return enitityTypeName;
            default:
                return enitityTypeName;
        }
    };
    /**
     * Gets the flag indicating whether or not the entity can be shown in the overlay.
     * @readonly
     * @type {boolean}
     */
    InputEntityComponent.prototype.hasLink = function () {
        return this.overlayService.entityWithOverlay(null, this.getLinkName(this.value));
    };
    /**
     * An outside click event
     */
    InputEntityComponent.prototype.clickOutside = function (e) {
        if (this.isOpen()) {
            _super.prototype.clickOutside.call(this, e);
            this.onDropdownChanged.emit(true); // Sorry, stupid on detectChanges stuff #2998
        }
    };
    return InputEntityComponent;
}(LookupInput));
export { InputEntityComponent };
